import { z } from "@/helpers/forms/zod";

export const ecoScoreSchema = z.object({
  catalogMediumId: z.string().min(1),
  climateChange: z.object({
    value: z.number().gte(0),
    unit: z.string().min(1),
  }),
  waterUse: z.object({
    value: z.number().gte(0),
    unit: z.string().min(1),
  }),
  photochemicalOzoneFormation: z.object({
    value: z.number().gte(0),
    unit: z.string().min(1),
  }),
});

export type EcoScoreFormInputs = z.infer<typeof ecoScoreSchema>;
